import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import last from 'lodash/fp/last'
import omit from 'lodash/fp/omit'
import { FormattedMessage, FormattedHTMLMessage } from '@dragonraider5/react-intl'
import { DOCUMENTS_CHECK_FAILING } from '../../../../../utils/exceptions/constants'
import { Link } from 'react-router-dom'
import Button from '../../../../../components/Button'
import FormActions from '../../../../../components/FormFields/FormAction/FormActions'
import FormError from '../../../../../components/FormFields/FormError'
import FieldHelp from '../../../../../components/FormFields/FieldHelp'
import FormInfo from '../../../../../components/FormFields/FormInfo'
// import { getYearPeriod } from './utils'
import UploadHaciendaField from './UploadHaciendaField'
import UploadFileField from './UploadFileField'
import createUploadHacienda from '../enhancers/uploadHaciendaEnhancer'
import createUploadFile from '../enhancers/uploadFileEnhancer'
import m from './messages'
import tips, { tipsNoAeat } from './tips'
import { getOrNull } from '../../../../../utils/selectors'
import { getExceptionMessage } from '../../../../../utils/exceptions'
import { getApplyToStepPath } from '../../../../MainRoutes/utils'

import { compileDocInfoPath } from '../utils'
import { stepStatuses } from '../../../constants'

const HaciendaUploader = createUploadHacienda(UploadHaciendaField)
const FileUploader = createUploadFile(UploadFileField)
const HaciendaBlockedHelp = styled(FieldHelp)`
  margin: 0;
`

const VASCO_ZIP_STARTS = [
  '01', '20', '31', '48'
]
// const CANARIAN_ZIP_STARTS = [
//   '35', '38'
// ]
// const NO_AEAT = [].concat(...VASCO_ZIP_STARTS, ['35', '38'])
// const isNoAeat = zip => NO_AEAT.some(code => zip.startsWith(code))
// // const isCanarianZip = zip => CANARIAN_ZIP_STARTS.some(code => zip.startsWith(code))
const isVascoZip = zip => VASCO_ZIP_STARTS.some(code => zip.startsWith(code))
const startsWithModel = model => model.startsWith('model')
// const isNoCanarian = model => !['model420', 'model425'].includes(model)

const showIfPresent = (model, requiredDocuments) => requiredDocuments.hasOwnProperty(model)
const showIfArray = (model, requiredDocuments) => showIfPresent(model, requiredDocuments) && requiredDocuments[model].ranges.length
const showIfTrue = (model, requiredDocuments) => showIfPresent(model, requiredDocuments) && requiredDocuments[model].required

const renderField = ({
  component: Component,
  model,
  requiredDocuments,
  key = model,
  isHaciendaBlocked,
  application,
  withPeriod,
  isVasco,
  zipCode,
  period,
  period_tax,
  year,
  submitError,
  uploadType,
  onChangeInput,
  handleParsingError,
  hasParsingError
}) => {
  const modelName = period ? model + period : model
  const withParsingError = hasParsingError.includes(modelName)

  // const toolTip = (
  //   isNoAeat(zipCode) &&
  //   startsWithModel(model) &&
  //   isNoCanarian(model)
  // ) ?
  //   tipsNoAeat[`noAeat${model}`] :
  //   tips[model]
  let toolTip = tips[model]
  // if (isCanarianZip(zipCode) && startsWithModel(model)) {
  //   if (model === 'model200') {
  //     toolTip = tipsNoAeat[`noAeat${model}`]
  //   }
  // }
  if (isVascoZip(zipCode) && startsWithModel(model)) {
    toolTip = tipsNoAeat[`noAeat${model}`]
  }

  return (
    <Component
      key={key}
      id={key}
      model={model}
      period={period}
      mandatory={requiredDocuments[model].required}
      onChangeInput={() => onChangeInput(model, period)}
      handleParsingError={(model, action) => handleParsingError(modelName, action)}
      label={(
        <FormattedMessage
          {...m[model]}
          values={{
            period: requiredDocuments[model].period || period, // : Array.isArray(withPeriod) ? withPeriod.join(' / ') : withPeriod,
            required: requiredDocuments[model].required,
            period_tax,
            year
          }}
        />
      )}
      application={application}
      success={application.documents.find(doc => (
        doc.name === model &&
        (period == null || parseInt(doc.period, 10) === period)
      )) != null}
      submitError={submitError}
      hasParsingError={withParsingError}
      tip={(
        <Fragment>
          {isHaciendaBlocked && (
            <HaciendaBlockedHelp>Lo sentimos en este momento no podemos conectarnos con Hacienda para descargar tu declaración.</HaciendaBlockedHelp>
          )}
          <FormattedHTMLMessage
            {...toolTip}
            values={{ uploadType }}
            tagName='span'
          />
        </Fragment>
      )}
      forceTip
      shrinkLabel
      full
    />
  )
}

export const renderHacienda = ({
  isVasco,
  isHaciendaBlocked,
  submitErrors,
  ...props
}) => {
  const period = props.withPeriod === undefined ? '' : props.withPeriod
  const hasParsingError = props.hasParsingError.includes(props.model + period)
  return renderField({
    isHaciendaBlocked,
    component: isVasco || isHaciendaBlocked || hasParsingError ? FileUploader : HaciendaUploader,
    uploadType: isVasco || isHaciendaBlocked || hasParsingError ? 'upload' : 'csv',
    submitError: getOrNull(props.model)(submitErrors),
    hasParsingError,
    ...props
  })
}

const renderFile = ({
  submitErrors,
  isHaciendaBlocked,
  ...props
}) => renderField({
  component: FileUploader,
  submitError: getOrNull(props.model)(submitErrors),
  uploadType: 'upload',
  ...props
})

const renderArrayUploads = renderer => ({
  model,
  application,
  isVasco,
  zipCode,
  requiredDocuments,
  submitErrors,
  ...props
}) => {
  const period_tax = application.document_info.period_tax
  let periods = requiredDocuments[model].ranges
  if (
    // trimestral and more than 2 periods
    (period_tax === 'trimestral' && periods.length === 3) ||
    // mensual and more than 6 periods
    (period_tax === 'mensual' && periods.length === 7)
  ) {
    // request only in period documents
    // if user uploads the allowed before period shows first period and consecutives
    const lastPeriod = last(periods)
    if (application.documents.find(doc =>
      doc.name === model && parseInt(doc.period, 10) === lastPeriod
    )) {
      periods = periods.slice(1, periods.length)
    } else {
      periods = periods.slice(0, periods.length - 1)
    }
  }
  const modelError = getOrNull(model)(submitErrors)

  return periods.map(period => renderer({
    ...props,
    model,
    key: `${model}-${period}`,
    requiredDocuments,
    application,
    isVasco,
    zipCode,
    period,
    withPeriod: period,
    period_tax: period_tax,
    year: moment().year(),
    submitError: modelError && modelError.ranges.find(v => v === period) ? modelError : null
  }))
}

const models = [
  ['model200', {
    shouldShow: showIfTrue,
    render: renderFile,
    // withPeriod: getYearPeriod({
    //   startPeriod: { month: 6, date: 1 },
    //   endPeriod: { month: 6, date: 20 },
    // })
  }],
  ['model100', {
    shouldShow: showIfPresent,
    render: renderFile,
    // withPeriod: getYearPeriod({
    //   startPeriod: { month: 3, date: 4 },
    //   endPeriod: { month: 6, date: 2 },
    // })
  }],
  ['model390', {
    shouldShow: showIfPresent,
    render: renderFile,
    // withPeriod: getYearPeriod({
    //   startPeriod: { month: 0, date: 1 },
    //   endPeriod: { month: 0, date: 30 },
    // })
  }],
  ['model303', {
    shouldShow: showIfArray,
    render: renderArrayUploads(renderFile)
  }],
  ['model425', {
    shouldShow: showIfPresent,
    render: renderFile
  }],
  ['model420', {
    shouldShow: showIfArray,
    render: renderArrayUploads(renderFile)
  }],
  ['model410', {
    shouldShow: showIfArray,
    render: renderArrayUploads(renderFile)
  }],
  ['model130', {
    shouldShow: showIfArray,
    render: renderArrayUploads(renderFile)
  }],
  ['balance_closed', {
    shouldShow: showIfTrue,
    render: renderFile
  }],
  ['auditory', {
    shouldShow: showIfTrue,
    render: renderFile
  }],
  ['balance', {
    shouldShow: showIfPresent,
    render: renderFile
  }],
  ['budget', {
    shouldShow: showIfPresent,
    render: renderFile
  }],
  ['prevision', {
    shouldShow: showIfPresent,
    render: renderFile
  }],
  ['certificateHacienda', {
    shouldShow: showIfPresent,
    render: renderFile
  }],
  ['certificateSegSocial', {
    shouldShow: showIfPresent,
    render: renderFile
  }],
  ['model347', {
    shouldShow: showIfPresent,
    render: renderFile,
    // withPeriod: getYearPeriod({
    //   startPeriod: { month: 1, date: 1 },
    //   endPeriod: { month: 1, date: 28 },
    // })
  }],
  ['rating', {
    shouldShow: showIfPresent,
    render: renderFile
  }],
  ['invoice', {
    shouldShow: showIfPresent,
    render: renderFile
  }],
  ['contract', {
    shouldShow: showIfPresent,
    render: renderFile
  }],
  ['discount', {
    shouldShow: showIfPresent,
    render: renderFile
  }],
  ['treasury', {
    shouldShow: showIfPresent,
    render: renderFile
  }],
  ['endorsement', {
    shouldShow: showIfPresent,
    render: renderFile
  }],
  ['other', {
    shouldShow: showIfPresent,
    render: renderFile
  }],
]

class DocumentsForm extends Component {
  state = {
    submitError: null,
    error: null,
    hasParsingError: []
  }

  componentDidUpdate(prevProps) {
    const { submitErrors } = this.state
    const { documents } = this.props.application
    if (
      submitErrors &&
      prevProps.application.documents !== documents
    ) {
      const newState = Object.entries(submitErrors).reduce((state, [model, validation]) => {
        if (validation.ranges) {
          const uploadedRanges = documents
            .filter(doc => doc.name === model)
            .map(doc => parseInt(doc.period, 10))
          const newRange = validation.ranges.filter(period => !uploadedRanges.includes(period))
          if (newRange.length) {
            return {
              ...state,
              [model]: {
                ...validation,
                ranges: newRange
              }
            }
          }
        } else if (!documents.find(doc => doc.name === model)) {
          return {
            ...state,
            [model]: validation
          }
        }
        return state
      }, {})

      this.setState({ submitErrors: newState })
    }
  }

  handleSubmit = async () => {
    this.setState({
      error: null,
      submitting: true
    })
    try {
      await this.props.checkDocuments(this.props.application.id)
      const nextStatus = stepStatuses.FINISHED
      this.props.redirect(getApplyToStepPath(nextStatus, this.props.application))
    } catch (error) {
      console.log(error)
      const stateToMerge = error.errorCode === DOCUMENTS_CHECK_FAILING ?
        { submitErrors: error.response.response.data }
        : {}

      this.setState({
        ...stateToMerge,
        error,
        submitting: false
      })
    }
  }

  onChangeWithError = (model, period) => {
    const errors = getOrNull(model)(this.state.submitErrors)
    if (!errors) {
      return
    }
    let newState
    if (errors.ranges) {
      const periodRanges = errors.ranges.filter(p => p !== period)
      if (periodRanges.length) {
        newState = {
          ...this.state.submitErrors,
          [model]: {
            ...errors,
            ranges: periodRanges
          }
        }
      } else {
        newState = omit(model, this.state.submitErrors)
      }
    } else {
      newState = omit(model, this.state.submitErrors)
    }

    this.setState({ submitErrors: newState })
  }

  handleParsingError = (model, action) => {
    console.log(model, action)
    if (action === 'add') {
      const hasNewParsingError = [...this.state.hasParsingError, model]
      this.setState({ hasParsingError: hasNewParsingError })
    } else if (action === 'remove') {
      const filtered = this.state.hasParsingError.filter(e => e !== model)
      this.setState({ hasParsingError: filtered })
    }
    return
  }

  render() {
    const {
      application,
      isHaciendaBlocked,
      jobResult: requiredDocuments
    } = this.props
    const { submitting, error, submitErrors, hasParsingError } = this.state

    let { zip_code: zipCode } = application.data
    if (zipCode.length === 4) zipCode = `0${zipCode}`

    const isVasco = VASCO_ZIP_STARTS.some(vasco => zipCode.startsWith(vasco))

    return (
      <Fragment>
        {models
          .filter(([model, { shouldShow }]) => shouldShow(model, requiredDocuments))
          // .map(([model, { render, withPeriod }]) => console.log(tips[model]) || [model, { render, withPeriod }])
          .map(([model, { render, withPeriod }]) => render({
            application,
            model,
            requiredDocuments,
            withPeriod,
            isVasco,
            zipCode,
            isHaciendaBlocked,
            submitErrors,
            hasParsingError,
            onChangeInput: this.onChangeWithError,
            handleParsingError: this.handleParsingError
          })
          )}
        <FormInfo>
          Los campos marcados con * son obligatorios.
        </FormInfo>
        {error && (
          <FormError>
            <FormattedMessage {...getExceptionMessage(error)} />
          </FormError>
        )}
        <FormActions>
          <Button onClick={this.handleSubmit} disabled={submitting}>Terminar solicitud</Button>
          <Link to={compileDocInfoPath({ id: application.id })}>Volver</Link>
        </FormActions>
      </Fragment>
    )
  }
}

export default DocumentsForm
